import React, { useEffect, useRef, useState } from "react";

export default function Carrusel({ data }) {
  const listRef = useRef(null);
  const currentIndex = useRef(0);
  const [_, forceUpdate] = useState(0); // Para forzar render

  // 👉 Función para mover a imagen actual
  const scrollToCurrentImage = () => {
    const listNode = listRef.current;
    if (!listNode) return;

    const item = listNode.querySelectorAll("li")[currentIndex.current];
    if (item) {
      item.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }
  };

  // 👉 Ir a siguiente imagen automáticamente
  const goAutomatico = () => {
    if (!data || data.length === 0) return;

    const isLast = currentIndex.current >= data.length - 1;
    currentIndex.current = isLast ? 0 : currentIndex.current + 1;
    forceUpdate(i => i + 1); // fuerza re-render para que se actualice el scroll
    scrollToCurrentImage();
  };

  // 👉 Navegación manual
  const scrollToImage = (dir) => {
    if (!data || data.length === 0) return;

    if (dir === "next") {
      currentIndex.current = currentIndex.current >= data.length - 1 ? 0 : currentIndex.current + 1;
    } else {
      currentIndex.current = currentIndex.current <= 0 ? data.length - 1 : currentIndex.current - 1;
    }
    forceUpdate(i => i + 1);
    scrollToCurrentImage();
  };

  // 👉 Auto slide cada 10s
  useEffect(() => {
    const interval = setInterval(goAutomatico, 10000);
    return () => clearInterval(interval);
  }, [data]);

    const GenerarRutaArch = (item) => {
        const ItemId = item.ItemId;
        const ArchivoId = item.ArchivoId;
        const Formato = item.Formato;
        const NombreArch = ArchivoId + "_" + ItemId + "." + Formato;
        
        const RutaArch =  "/api/static/" + item.RutaArch + "/" + NombreArch;
        return RutaArch;
      };
    

  return (
    <div className="relative w-full h-full overflow-hidden">
      {/* Flechas */}
      <div className="absolute top-1/2 left-2 z-10 text-white text-4xl cursor-pointer select-none" onClick={() => scrollToImage("prev")}>&#10092;</div>
      <div className="absolute top-1/2 right-2 z-10 text-white text-4xl cursor-pointer select-none" onClick={() => scrollToImage("next")}>&#10093;</div>

      {/* Lista de imágenes */}
      <ul
        ref={listRef}
        className="flex w-full h-full overflow-hidden scroll-smooth scroll-snap-x"
        style={{ scrollSnapType: "x mandatory" }}
      >
        {data.map((item) => {
          const ruta = GenerarRutaArch(item);
          return (
            <li key={`${item.ArchivoId}${item.ItemId}`} className="flex-none w-full h-full scroll-snap-align-center">
              <img src={ruta} alt="" className="w-full h-full object-contain" />
            </li>
          );
        })}
      </ul>
    </div>
  );
}
